import { Button, Icon, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Text, useDisclosure } from "@chakra-ui/react";
import HoverableIconButton from "components/Atomos/Buttons/HoverableIconButton";
import { useState } from "react";

import { FiEyeOff, FiUpload } from "react-icons/fi";

type PublishButtonProps = {
    isInDraft: boolean;
    onConfirm: () => void | Promise<void>;
}

const PublishButton = ({
    onConfirm,
    isInDraft
}: PublishButtonProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        isOpen,
        onClose,
        onOpen
    } = useDisclosure();

    const handlePublishing = async () => {
        setIsLoading(true);
        await onConfirm?.();
        onClose();
        setIsLoading(false);
    }

    return (
        <Popover returnFocusOnClose={false} isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
            <PopoverTrigger>
                <HoverableIconButton
                    label={isInDraft ? "Publicar" : 'Ocultar'}
                    icon={<Icon as={isInDraft ? FiUpload : FiEyeOff} />}
                />
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>
                    {isInDraft && "Publicar essa postagem?"}
                    {!isInDraft && "Ocultar essa postagem?"}
                </PopoverHeader>
                <PopoverBody>
                    <Text whiteSpace="break-spaces">
                        Você tem certeza que deseja {isInDraft ? 'publicar' : 'ocultar'} essa postagem?
                        Você poderá {isInDraft ? 'ocultar' : 'publicar'} ela novamente a qualquer momento.
                    </Text>
                </PopoverBody>
                <PopoverFooter>
                    <Button colorScheme="green" isLoading={isLoading} isFullWidth onClick={handlePublishing}>
                        {isInDraft ? 'Publicar' : 'Ocultar'}
                    </Button>
                </PopoverFooter>
            </PopoverContent>
        </Popover>

    )
}

export default PublishButton